import { createSlice } from "@reduxjs/toolkit";

// Tracks two independent signals baseQuery.js writes to:
// - isOnline: the browser's link-layer state (window online/offline events,
//   synced by _hooks/useOnlineStatus.js). A captive portal or a dead API
//   server can both report `navigator.onLine === true`, which is exactly
//   why this alone isn't enough.
// - isServerReachable: whether the last state-changing API response was a
//   network/timeout failure vs a success. This is the signal that actually
//   distinguishes "wifi is fine, the server isn't answering" from "you're
//   offline" - see OfflineBanner.
// Deliberately excluded from redux-persist's whitelist in store.js: a
// persisted `isServerReachable: false` would rehydrate a phantom banner on
// the next cold load with no request in flight.
const initialState = {
  isOnline: typeof navigator === "undefined" ? true : navigator.onLine !== false,
  isServerReachable: true,
};

const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    setOnline: (state, action) => {
      state.isOnline = action.payload;
    },
    markServerUnreachable: (state) => {
      state.isServerReachable = false;
    },
    markServerReachable: (state) => {
      state.isServerReachable = true;
    },
  },
});

export const { setOnline, markServerUnreachable, markServerReachable } = networkSlice.actions;

export const selectIsOnline = (state) => state.network.isOnline;
export const selectIsServerReachable = (state) => state.network.isServerReachable;

export default networkSlice.reducer;
